// This dialog shows the wallet deposits for each week.   It categorises the
// deposits into the following : Etransfer: $50.00, Cash, F2PM Credits, Refunds,
// Mileage, Packaging, Credit Card, Misc
import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import PaymentInfoListDialog from "./PaymentInfoListDialog.jsx";
import PaymentInfoByDateGridDialog from "./PaymentInfoByDateGridDialog.jsx";
import groupWalletTransactionsByWeek from "../utils/groupWalletTransactionsByWeek.js";

function PaymentHistoryTotalsBox(props) {
  // communityWallets contains all the wallets.
  const { onClose, open, communityWallets } = props;
  // Sorts the deposits into a weekly Summary and sortedWeeks is an array of all the weeks.
  const { weeklySummary, sortedWeeks } =
    groupWalletTransactionsByWeek(communityWallets);

  const handleClose = () => {
    onClose(false);
  };

  return (
    <Dialog
      fullWidth={true}
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">Payment History</DialogTitle>
      <DialogContent>
        {sortedWeeks.map((weekKey) => {
          const summary = weeklySummary[weekKey];
          const year = weekKey.substring(0, 4);
          const month = weekKey.substring(4, 6);
          const day = weekKey.substring(6, 8);
          const displayDate = `${month}-${day}-${year}`;

          return (
            <div
              key={weekKey}
              style={{ borderBottom: "1px solid #ccc", marginBottom: "1rem" }}
            >
              <h4>Week Ending: {displayDate}</h4>
              <p>Etransfer: ${summary.ETransfer.toFixed(2)}</p>
              <p>Cash: ${summary.Cash.toFixed(2)}</p>
              <p>F2PM Credits: ${summary.F2PMCredits.toFixed(2)}</p>
              <p>Refunds: ${summary.Refunds.toFixed(2)}</p>
              <p>Mileage: ${summary.Mileage.toFixed(2)}</p>
              <p>Packaging: ${summary.Packaging.toFixed(2)}</p>
              <p>Credit Card: ${summary.CreditCard.toFixed(2)}</p>
              <p>Misc: ${summary.Misc.toFixed(2)}</p>

              <PaymentInfoListDialog
                weeklySummary={weeklySummary}
                weekKey={weekKey}
              />
              <PaymentInfoByDateGridDialog
                weeklySummary={weeklySummary}
                weekKey={weekKey}
              />
            </div>
          );
        })}
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

PaymentHistoryTotalsBox.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function PaymentInfoDialog({ communityWallets }) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <div>
        <div>
          <Button color="primary" onClick={handleClickOpen}>
            Payment Info
          </Button>
        </div>
      </div>
      <PaymentHistoryTotalsBox
        open={open}
        onClose={handleClose}
        communityWallets={communityWallets}
      />
    </div>
  );
}
